import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '../../ui-v2';

/**
 * CopiarEnlace — bloque de ÉXITO con el enlace del formulario y un botón de copiar.
 *
 * El enlace lleva el token en claro y solo existe en memoria tras crear o reenviar (no se
 * persiste ni se puede volver a pedir). Por eso "Copiar enlace" vive SOLO en este estado de
 * éxito, nunca como acción de fila de la tabla (cerrado esto, no hay enlace que copiar).
 */
export default function CopiarEnlace({ enlace }) {
  const [copiado, setCopiado] = useState(false);

  async function copiar() {
    try {
      await navigator.clipboard.writeText(enlace);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (_) {
      // Fallback: selección manual si el navegador bloquea el portapapeles.
      const el = document.getElementById('incorp-enlace-input');
      if (el) { el.focus(); el.select(); }
    }
  }

  return (
    <div className="space-y-2">
      <p className="text-xs text-v25-ink-500">
        Este enlace se muestra <strong>una sola vez</strong>. Cópialo ahora si lo necesitas; también se ha
        incluido en el correo al candidato.
      </p>
      <div className="flex items-center gap-2">
        <input
          id="incorp-enlace-input"
          readOnly
          value={enlace}
          onFocus={(e) => e.target.select()}
          className="min-w-0 flex-1 rounded-v25-md border border-v25-line bg-v25-surface-sunken px-2.5 py-1.5 text-xs text-v25-ink-700"
        />
        <Button variant="outline" size="sm" onClick={copiar}>
          {copiado ? <Check /> : <Copy />}{copiado ? 'Copiado' : 'Copiar enlace'}
        </Button>
      </div>
    </div>
  );
}
